import PageLayout from "../../components/UI/Layout/PageLayout";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import useProperties from "../../hooks/use-properties";
import { fetchBalanceTenants } from "../../api/Balance_tenants";

import useAuth from "../../hooks/use-auth.js";

export const ROOT_PATH = "/bailleur/properties/";

export default function PropertyRootPage() {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const { properties } = useProperties();
  const [balances, setBalances] = useState([]);

  function editPropertyHandler(propertyId) {
    navigate(`${ROOT_PATH}${propertyId}/edit`);
  }

  useEffect(() => {
    (async () => {
      setBalances(await fetchBalanceTenants(auth.accessToken));
    })();
  }, [auth.accessToken]);

  return (
    <PageLayout isBailleur>
      <Outlet
        context={{
          editPropertyHandler: editPropertyHandler,
          properties,
          balances: balances,
        }}
      />
    </PageLayout>
  );
}
